import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { first } from 'rxjs/operators';
import { AuthenticationService } from '../../../core/authentication';
import { ToastrService } from "ngx-toastr";
import { ServiceProvider } from '../../../core/service/service.provider';

@Component({
  selector: 'app-forgotpassword-form',
  templateUrl: './forgotpassword-form.component.html'
})
export class ForgotpasswordFormComponent implements OnInit {
  forgotpasswordForm: FormGroup;
  loading = false;
  submitted = false;
  returnUrl: string;

  constructor(
    private formBuilder: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private authenticationService: AuthenticationService,
    private toastr: ToastrService,
    public dataService: ServiceProvider
  ) { 
  }

  ngOnInit() {
    this.forgotpasswordForm = this.formBuilder.group({
      mail: ['', Validators.required],
    });

    // get return url from route parameters or default to '/'
    this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/login';
  }

  // convenience getter for easy access to form fields
  get f() { return this.forgotpasswordForm.controls; }


  forgotpasswordSubmit() {
    this.submitted = true;

    // stop here if form is invalid
    if (this.forgotpasswordForm.invalid) {
        return;
    }

    this.loading = true;
    this.dataService.post("ForgetPassword", null, this.forgotpasswordForm.value)
    .subscribe((type) => {
      this.toastr.success("Password reset requested successfully. Password will be send your mail." , 'Success');
      this.router.navigate(['/login'])
    }, (err) => {
      if(Array.isArray(err)){
        for(let er in err){
          this.toastr.error(er + ' - '+this.formErrValue(err[er]) ,'Failed');
        }
      }else{
        this.toastr.error(err.error ,'Failed');
      }
    });
    // this.authenticationService.login(this.f.username.value)
    // .pipe(first())
    // .subscribe(
    //   data => {
    //     if(data.access_token){
    //       this.router.navigate([this.returnUrl]);
    //       this.toastr.success("Forgotpassword link send successfully",'Success');
    //     } else {
    //       this.toastr.error("Unautherised attempt!",'Failed');
    //     }
    //   },
    //   error => {
    //     this.toastr.error("Unautherised attempt!",'Failed');
    //     this.loading = false;
    //   });
    }

    formErrValue(er){
      if(Array.isArray(er)){
        return er.join(', ')
      }else{
        return er
      }
    }

}